<template>
    <div class="pa-12 px-md-20 py-md-22 d-flex border-bottom">
        <p :class="'font-weight-bold ' + spacing">
            {{tit}}
        </p>
        <p class="d-flex align-baseline">
            {{sc}}
            <slot name="content" />
        </p>
    </div>
</template>

<script>

export default{
    props : {
        tit : {type :String, default : ""},
        sc : {type :String, default : ""},
        spacing : {type :String, default : ""},
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>